import angular from 'angular'

import noContentError from './component/noContentError.js'

export default angular
  .module('portalApp.noContentError', [])
  .component('noContentError', noContentError).name
